export default __webpack_public_path__ + "static/media/f2b9d3f8a3692d8b0a0c7c957b3f29171602952908419.1fbefda2.webp";